import React, { useEffect, useState } from 'react'
import { HStack, Select } from '@chakra-ui/react'

interface Props {
  startYear: string
  endYear: string
  dateString: string
  setDateString:
    | React.Dispatch<React.SetStateAction<string>>
    | ((value: string) => void)
}

export default function BasicMonthPicker({
  startYear,
  endYear,
  dateString,
  setDateString,
}: Props) {
  // Parse the initial dateString (expected format: YYYY-MM)
  const parts = dateString.split('-')
  const initialYear = parts[0] && parts[0] !== '0' ? parts[0] : '0'
  const initialMonth = parts[1] && parts[1] !== '0' ? parts[1] : '0'

  const [year, setYear] = useState(initialYear)
  const [month, setMonth] = useState(initialMonth)

  // Update parent when year or month changes
  useEffect(() => {
    setDateString(`${year}-${month}`)
  }, [year, month])

  // Sync internal state if dateString prop changes externally
  useEffect(() => {
    const parts = dateString.split('-')
    const newYear = parts[0] && parts[0] !== '0' ? parts[0] : '0'
    const newMonth = parts[1] && parts[1] !== '0' ? parts[1] : '0'

    if (newYear !== year) {
      setYear(newYear)
    }
    if (newMonth !== month) {
      setMonth(newMonth)
    }
    // Only sync when dateString changes, not when internal state changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateString])

  const years = arrayRange(parseInt(startYear), parseInt(endYear), 1)

  return (
    <HStack>
      <Select
        maxWidth={90}
        value={year}
        onChange={(e) => setYear(e.target.value)}
      >
        <option value='0'>Year</option>
        {years.reverse().map((y, index) => (
          <option key={index} value={y}>
            {y}
          </option>
        ))}
      </Select>
      <Select
        maxWidth={130}
        value={month}
        onChange={(e) => setMonth(e.target.value)}
      >
        {months.map((m, index) => (
          <option
            key={index}
            value={index > 9 ? index.toString() : '0' + index}
          >
            {m}
          </option>
        ))}
      </Select>
    </HStack>
  )
}

function arrayRange(start: number, stop: number, step: number) {
  return Array.from(
    { length: (stop - start) / step + 1 },
    (_, index) => start + index * step
  )
}

const months = [
  'Month',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
